import { getBlockId } from "@/services/contentful/assemblies/page/adapter/utils";
import {
  UiConfigurationAdapter,
  type UiConfigurationInput,
} from "@/services/contentful/topics/UIConfiguration/ui-configuration.adapter";
import { DEFAULT_PRODUCT_LISTING_PAGE_SIZE } from "@/services/product/product-listing-pagination-state";
import type { ProductListingPageBlock } from "@/types/page-block";

export interface ProductListItemInput {
  __typename: "ProductListItem";
  sys?: { id: string };
  productCode?: string | null;
  colorCode?: string | null;
}

export interface ProductListingInput {
  sys?: { id: string };
  __typename: "ProductListing";
  internalName: string;
  title?: string | null;
  anchorId?: string;
  productCategory?: string | null;
  specificProductsCollection?: {
    items: ProductListItemInput[];
  } | null;
  defaultSort?: string | null;
  searchQuery?: string | null;
  showFilters?: boolean | null;
  showSorting?: boolean | null;
  showCarouselNavigationArrows?: boolean | null;
  variant?: "grid" | "carousel" | null;
  paginationMode?: string | null;
  pageSize?: number | null;
  uiConfiguration?: UiConfigurationInput;
}

export function ProductListingAdapter(
  item: ProductListingInput,
  index: number
): ProductListingPageBlock {
  const uiConfig = item.uiConfiguration
    ? UiConfigurationAdapter(item.uiConfiguration)
    : undefined;

  const specificProducts = (
    item.specificProductsCollection?.items ?? []
  ).flatMap((entry) =>
    entry.productCode
      ? [
          {
            productCode: entry.productCode,
            colorCode: entry.colorCode ?? undefined,
          },
        ]
      : []
  );

  return {
    sys: item.sys,
    id: getBlockId(item, index),
    __typename: item.__typename,
    internalName: item.internalName,
    title: item.title ?? undefined,
    anchorId: item.anchorId,
    productCategory: item.productCategory ?? "",
    specificProducts:
      specificProducts.length > 0 ? specificProducts : undefined,
    searchQuery: item.searchQuery ?? "",
    defaultSort: item.defaultSort ?? "",
    showFilters: item.showFilters ?? true,
    showSorting: item.showSorting ?? true,
    showCarouselNavigationArrows: item.showCarouselNavigationArrows ?? false,
    variant: item.variant ?? "grid",
    paginationMode: item.paginationMode === "showAll" ? "showAll" : "paginate",
    pageSize: item.pageSize ?? DEFAULT_PRODUCT_LISTING_PAGE_SIZE,
    backgroundColor: uiConfig?.backgroundColor,
    paddingTop: uiConfig?.paddingTop,
    paddingBottom: uiConfig?.paddingBottom,
  };
}
